import { useQuery } from 'react-query'
import { IndividualFiltersService } from '~/api/services/individualFilters'
import { onError } from '~/utils/helpers'

const getGeneralFilterInfo = () => useQuery(
  'general-filter-info',
  () => IndividualFiltersService.filtersGeneralInfo(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getGeneralFilters = () => useQuery(
  'general-filters',
  () => IndividualFiltersService.filtersGeneralIndex(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getGeographicalInfo = () => useQuery(
  'geographical-filter-info',
  () => IndividualFiltersService.filtersGeographicInfo(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getGeopgraphicalFilters = () => useQuery(
  'geographical-filters',
  () => IndividualFiltersService.filtersGeographicIndex(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getAmountInfo = () => useQuery(
  'amount-filter-info',
  () => IndividualFiltersService.filtersAmountInfo(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getAmountFilters = () => useQuery(
  'amount-filters',
  () => IndividualFiltersService.filtersAmountIndex(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getRadiusInfo = () => useQuery(
  'radius-filter-info',
  () => IndividualFiltersService.filtersRadiusInfo(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getRadiusFilters = () => useQuery(
  'radius-filters',
  () => IndividualFiltersService.filtersRadiusIndex(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getNotAssignedFarmers = (isOpenModal: boolean, type: string, data) => useQuery(
  `not-assigned-farmers${isOpenModal}-${type}-filters`,
  () => isOpenModal && IndividualFiltersService.filtersNotAssignedFarmers(type, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getAssignedFarmers = (
  type: string,
  id: string,
  data: unknown) => useQuery(
  `assigned-farmers${id}-${type}-filters`,
  () => Boolean(id) && IndividualFiltersService.filtersAssignedFarmers(type, id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const IndividualFiltersQuery = {
  getAmountInfo,
  getGeneralFilterInfo,
  getGeographicalInfo,
  getGeneralFilters,
  getGeopgraphicalFilters,
  getAmountFilters,
  getRadiusFilters,
  getRadiusInfo,
  getAssignedFarmers,
  getNotAssignedFarmers
}

export default IndividualFiltersQuery